import { useMemo } from "react";
import { Flex, Tabs, Typography } from "antd";
import { useCan, useTranslate } from "@refinedev/core";
import { useSession } from "hooks/useSession";
import { PreferencesTab } from "./components/PreferencesTab";
import { DataExportTab } from "./components/DataExportTab";
import { IntegrationsTab } from "./components/IntegrationsTab";

const { Title, Text } = Typography;

export const OrganizationPreferencesPage = () => {
  const t = useTranslate();
  const { currentOrganization } = useSession();
  const { data: canEditOrg } = useCan({
    resource: "organization",
    action: "edit",
  });

  const items = useMemo(() => {
    const tabs = [
      {
        key: "preferences",
        label: t("media.organizations.tabs.preferences"),
        children: <PreferencesTab />,
      },
    ];
    if (canEditOrg?.can) {
      tabs.push(
        {
          key: "data-export",
          label: t("media.organizations.tabs.dataExport"),
          children: <DataExportTab />,
        },
        {
          key: "integrations",
          label: t("media.organizations.tabs.integrations"),
          children: <IntegrationsTab />,
        }
      );
    }
    return tabs;
  }, [canEditOrg?.can, t]);

  return (
    <Flex vertical gap="large" style={{ width: "100%" }}>
      <Title level={2} style={{ marginBottom: 0 }}>
        {t("media.organizations.index.organizationSettings")}
      </Title>
      {currentOrganization?.id && (
        <Text type="secondary" copyable={{ text: currentOrganization.id }}>
          {t("media.organizations.index.organizationId")}:{" "}
          {currentOrganization.id}
        </Text>
      )}
      <Tabs items={items} />
    </Flex>
  );
};

export default OrganizationPreferencesPage;
